import { render, staticRenderFns } from "./PartRoleCharts.vue?vue&type=template&id=4831fe3f"
import script from "./PartRoleCharts.vue?vue&type=script&setup=true&lang=js"
export * from "./PartRoleCharts.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/SysClass-Web-App/SysClass-Web-App/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4831fe3f')) {
      api.createRecord('4831fe3f', component.options)
    } else {
      api.reload('4831fe3f', component.options)
    }
    module.hot.accept("./PartRoleCharts.vue?vue&type=template&id=4831fe3f", function () {
      api.rerender('4831fe3f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/role/components/PartRoleCharts.vue"
export default component.exports